// removed by extract-text-webpack-plugin
module.exports = {"loadingContainer":"Ga95b58","loadingImage":"G5969cb"};